const Calendar = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 12 14"
        data-name="calendar_icon_boundaryless_v1 1X"
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={14}
        fill="currentColor"
        stroke="currentColor"
        {...props}
    >
        <g data-name="Rectangle 2370" fill="none">
            <path stroke="none" d="M0 2h12v12H0z" />
            <path d="M.5 2.5h11v11H.5z" />
        </g>
        <path data-name="Line 196" fill="none" d="M3.429 0v2" />
        <path data-name="Line 197" fill="none" d="M8.143 0v2" />
        <path data-name="Line 198" fill="none" d="M3 4.813h6" />
    </svg>
);

export default Calendar;
